module.exports = __webpack_public_path__ + "static/media/noti--red.5ad13eeb.svg";